import { Button } from "reactstrap";

const Popup = (props) => {
  return (
    <>
      <div className='popup-overlay'/>
      <div className="popup">
        {!!props.title && (
          <div className='popup-header'>
            {props.title}
          </div>
        )}
        <div className='popup-body'>{props.children}</div>
        <div className='popup-footer'>
          <Button color="secondary" outline onClick={props.cancel}>
            Zamknij
          </Button>
          {!!props.showSubmit && (
            <Button color="primary" onClick={props.submit} className="popup-footer-submit">
              Zapisz
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default Popup;